import React, { useState, useEffect } from 'react';
import './ScrollProgress.css';

function ScrollProgress() {
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const progress = (window.scrollY / totalHeight) * 100;
            setScrollProgress(progress);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="scroll-progress-container">
            <div 
                className="scroll-progress-bar" 
                style={{ width: `${scrollProgress}%` }}
            />
        </div>
    );
}

export default ScrollProgress;
